import { forwardRef } from 'react';
import type { TArticle } from 'shared/types/carousel';
import * as styles from './styles.css';
import { ArticleParagraph1, ArticleParagraph2 } from '@cian/ui-kit';

type TArticleViewProps = Omit<TArticle, 'image'> & {
  src?: string;
  isImageLoaded: boolean;
  onImageLoad: () => void;
  onImageError: () => void;
};

export const Article = forwardRef<HTMLAnchorElement, TArticleViewProps>(function Article(
  { src, isImageLoaded, onImageLoad, onImageError, title, url, minutes },
  ref,
) {
  return (
    <a ref={ref} className={styles['container']} href={url} target="_blank" rel="noreferrer">
      <div className={styles['image']}>
        {!isImageLoaded && <div className={styles['image-loader']} aria-hidden />}
        <img
          className={isImageLoaded ? styles['image-visible'] : styles['image-hidden']}
          src={src}
          alt={title}
          loading="lazy"
          decoding="async"
          onLoad={onImageLoad}
          onError={onImageError}
        />
      </div>
      <div className={styles['content']}>
        <ArticleParagraph1>{title}</ArticleParagraph1>
        <ArticleParagraph2 color="icon-secondary-default">{minutes} мин. чтения</ArticleParagraph2>
      </div>
    </a>
  );
});
